import { toast } from "react-hot-toast";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";
import { useHandleNetworkError } from "utils/useHandleNetworkError";

export const useUpdateConsultationType = (onSuccess) => {
  const queryClient = useQueryClient();

  const handleNetworkError = useHandleNetworkError(
    "Error updating consultation type"
  );

  const tenantVal = localStorage.getItem("kinesin-tenant");

  return useMutation({
    mutationFn: async ({ appointmentId }) => {
      const axiosInstance = createAxiosInstance();
      const response = await axiosInstance.post(
        `/${tenantVal}/appointment/id/${appointmentId}/converttovideo`
      );
      return response.data;
    },
    onSuccess: (data) => {
      toast.success("Consultation type updated!");
      queryClient.invalidateQueries({ queryKey: ["appointments"] });
      queryClient.invalidateQueries({ queryKey: ["monthSlotCounts"] });
      queryClient.invalidateQueries({ queryKey: ["consultation"] });
      queryClient.invalidateQueries({ queryKey: ["activeConsultation"] });
      onSuccess?.(data);
    },
    onError: handleNetworkError,
  });
};
